import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'whatsapp'
})
export class WhatsappPipe implements PipeTransform {
  
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return '';

    // 1. Perform the regex formatting
    const formatted = value
      .replace(/\*(.*?)\*/g, '<b>$1</b>')
      .replace(/_(.*?)_/g, '<i>$1</i>')
      .replace(/~(.*?)~/g, '<del>$1</del>');

    // 2. Mark it as safe HTML so Angular doesn't block it
    return this.sanitizer.bypassSecurityTrustHtml(formatted);
  }
}